/* eslint-disable @typescript-eslint/no-explicit-any */

import { IconButton } from 'components/Blocks/Buttons';
import { ChevronDownIcon, ChevronUpDownIcon, ChevronUpIcon } from 'components/Blocks/Icons';

import { useTable } from '../../Table';
import { TableColumn } from '../../types';

import { getColumnKey } from './utils';
import { quickSwitch } from 'utils/conditions';

interface SortButtonProps {
  column: TableColumn<any>;
  index: number;
}

export function SortButton({ column, index }: SortButtonProps): JSX.Element {
  const { sort, dispatch } = useTable();

  const columnKey = getColumnKey(column, index);

  const handleSort = () => {
    const sameColumn = columnKey === sort?.key;

    if (!sameColumn) return dispatch({ sort: { key: columnKey, direction: 'ASC' } });

    dispatch({
      sort: {
        key: columnKey,

        direction: quickSwitch(sort?.direction, [
          { is: null, then: 'ASC' },
          { is: undefined!, then: 'ASC' },
          { is: 'ASC', then: 'DESC' },
          { is: 'DESC', then: null },
        ]),
      },
    });
  };

  const icon =
    columnKey === sort?.key ? (
      quickSwitch(sort?.direction, [
        { is: 'ASC', then: <ChevronUpIcon color="secondary" size={12} /> },
        { is: 'DESC', then: <ChevronDownIcon color="secondary" size={12} /> },
        { is: true, then: <ChevronUpDownIcon size={10} /> },
      ])
    ) : (
      <ChevronUpDownIcon size={10} />
    );

  return (
    <IconButton className="p-0.5" onClick={handleSort}>
      {icon}
    </IconButton>
  );
}
